import { useState, useEffect } from 'react';
import api from '../Api';

export function useContactPersons(customerId) {
    const [contactPersons, setContactPersons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchContactPersons = async () => {
        if (!customerId) {
            setContactPersons([]);
            return;
        }

        setLoading(true);
        try {
            const response = await api.get(`/customers/${customerId}/contact-persons`);
            setContactPersons(response.data || []);
            setError(null);
        } catch (err) {
            console.error('Error fetching contact persons:', err);
            setError(err.message);
            setContactPersons([]);
        } finally {
            setLoading(false);
        }
    };

    const addContactPerson = async (contactPersonData) => {
        try {
            const response = await api.post('/contact-persons', contactPersonData);
            await fetchContactPersons(); // Refresh list
            return response.data;
        } catch (err) {
            console.error('Error adding contact person:', err);
            throw err;
        }
    };

    const updateContactPerson = async (id, contactPersonData) => {
        try {
            const response = await api.put(`/contact-persons/${id}`, contactPersonData);
            await fetchContactPersons(); // Refresh list
            return response.data;
        } catch (err) {
            console.error('Error updating contact person:', err);
            throw err;
        }
    };

    const deleteContactPerson = async (id) => {
        try {
            await api.delete(`/contact-persons/${id}`);
            await fetchContactPersons(); // Refresh list
        } catch (err) {
            console.error('Error deleting contact person:', err);
            throw err;
        }
    };

    useEffect(() => {
        fetchContactPersons();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerId]);

    return {
        contactPersons,
        loading,
        error,
        addContactPerson,
        updateContactPerson,
        deleteContactPerson,
        refreshContactPersons: fetchContactPersons
    };
}

